import {dd,store,app} from 'systems/imports'

import BaseApi from 'api/BaseApi'
import { normalize, schema, Array } from 'normalizr';

/**
 */
class Order extends BaseApi{
  static getClassName(){ return 'Order' }

  static findOrder(input){
    return app.make("axios").get(`v1/order/${input["order_id"]}`)
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }

  static getOrders(input){
    return app.make("axios").get(`v1/order`)
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }

  static updateQrderQuestionnaireAnswer(input){
    return app.make("axios").post(`v1/order/${input["order_id"]}/order-questionnaire-answer`,input)
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }

  static updateOrdererQuestionnaireAnswer(input){
    return app.make("axios").post(`v1/order/${input["order_id"]}/orderer-questionnaire-answer`,input)
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }


}
export default Order



// WEBPACK FOOTER //
// ./src/api/Order.js